<div class="body">
  <i (click)="close()" class="fas fa-times"></i>
  <img src="{{ image }}" alt="" />
</div>
